import { motion } from "framer-motion";
import TierBadge from "@/components/TierBadge";

// Circular gauge for Credibility Score (0-1000)
export default function CredibilityGauge({ score = 0, tier = "Starter", size = 260 }) {
  const max = 1000;
  const pct = Math.min(score / max, 1);
  const r = (size - 28) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct);

  return (
    <div className="relative inline-block" style={{ width: size, height: size }} data-testid="credibility-gauge">
      <svg viewBox={`0 0 ${size} ${size}`} className="w-full h-full -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#E5E7EB"
          strokeWidth="14"
        />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#059669"
          strokeWidth="14"
          strokeLinecap="butt"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <span className="eyebrow">EthicCred Score</span>
        <span className="font-display text-5xl font-black mt-1" data-testid="score-value">{score}</span>
        <span className="text-xs font-mono-plex text-ec-ink-soft mt-1">/ {max}</span>
        <div className="mt-2">
          <TierBadge tier={tier} size="sm" />
        </div>
      </div>
    </div>
  );
}
